//////////////////
// IMPORTS
//////////////////
// schema
import * as ISchema from "@schema";
// libraries
import * as React from "react";
import { connect } from "react-redux";
import { createFragmentContainer } from "react-relay";
// chrome-event-suggested-times imports
import { IContainer, IProps, IState } from "./ChromeEventSuggestedTimes.d";
import { chromeEventSuggestedTimesFragments } from "./ChromeEventSuggestedTimes.gql";
import * as s from "./ChromeEventSuggestedTimes.styles";
// other internals
import { EventSchedulerSuggestedTime } from "@components/event-scheduler-suggested-time";
// state
import { IReduxState } from "@reducers/root.reducer";
import { setActiveViewEvent } from "@actions/chrome-extension.actions";
import { makeEventSchedulerViewActive } from "@actions/feed-scheduler.actions";
import { snackBarOpen } from "@actions/snack-bar.actions";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";

//////////////////
// COMPONENT
//////////////////
class ChromeEventSuggestedTimesCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      savingEvent: false,
      selectedSlot: null,
    };
  }

  // ~-~-~-~-~-~-~-
  // Helpers
  // ~-~-~-~-~-~-~-
  private onSlotSelect = (selectedSlot: ISchema.ISchedulingSlot) => {
    this.setState({ selectedSlot });
    this.props.onChange(selectedSlot);
  };

  // ~-~-~-~-~-~-~-
  // Render
  // ~-~-~-~-~-~-~-
  private renderSlot = (
    schedulingResponse: ISchema.ISchedulingResponse,
    slot: ISchema.ISchedulingSlot | undefined,
    index: number,
  ) => {
    const { qualifiers } = schedulingResponse;
    if (!slot) {
      return <span key={index} />;
    }

    const isSelected =
      this.state.selectedSlot &&
      this.state.selectedSlot.timeRange.startTime.dateOrDateTime ===
        slot.timeRange.startTime.dateOrDateTime;

    return (
      <EventSchedulerSuggestedTime
        key={index}
        schedulingSlot={slot}
        org={this.props.org}
        onClick={this.onSlotSelect}
        duration={this.props.minutesDuration}
        persons={[]}
        qualifiers={qualifiers}
        highlight={!!isSelected}
      />
    );
  };

  public render() {
    const { schedulingResponseErrorable, classes } = this.props;

    if (
      !schedulingResponseErrorable ||
      schedulingResponseErrorable.__typename === "GraphEntityError"
    ) {
      return <div>error</div>;
    }

    const { slots } = schedulingResponseErrorable;
    if (!slots.length || slots.length < 1) {
      return <div>No results found. Try viewing different dates or selecting fewer people.</div>;
    }

    return (
      <div className={classes.slotContainer}>
        {slots.map((slot, i) => this.renderSlot(schedulingResponseErrorable, slot, i))}
      </div>
    );
  }
}

//////////////////
// WITH STYLES
//////////////////
const ChromeEventSuggestedTimesStyled = withStyles(s.styles)(
  ChromeEventSuggestedTimesCmpt,
) as React.ComponentClass<IProps>;

//////////////////
// REDUX
//////////////////
function mapStateToProps(state: IReduxState, _ownProps: IContainer) {
  return {
    schedulingSessionId: state.feedScheduler.schedulingSessionId,
    reschedulerEvent: state.feedScheduler.reschedulerEvent,
  };
}

const reduxContainer = connect(mapStateToProps, {
  makeEventSchedulerViewActive,
  setActiveViewEvent,
  snackBarOpen,
})(ChromeEventSuggestedTimesStyled);

//////////////////
// RELAY
//////////////////
export const ChromeEventSuggestedTimes = createFragmentContainer<IContainer>(
  reduxContainer,
  chromeEventSuggestedTimesFragments,
);
